import { Badge } from "@marekl/adminer/components";
import type { MessageState } from "../../lib/queries/messages";
import { STATE_LABELS, STATE_PILL } from "./messageConstants";

/**
 * The state as a rubber stamp. `soft` is the library's bounded chip — fill,
 * edge and radius — which the theme's badge tokens set to a stamped outline in
 * the state's ink; `ghost` is ink alone and deliberately ignores those tokens.
 *
 * A message being sent right now is the one live row in a list of history, so
 * its dot breathes (and holds still under `prefers-reduced-motion`).
 */
export function MessageStateBadge({ state }: { state: MessageState }) {
  return (
    <Badge
      weight="soft"
      variant={STATE_PILL[state]}
      // The dot marks the one state that is still moving; on the six settled
      // states it is decoration, and the stamp already carries the colour.
      dot={state === "leased"}
      className={state === "leased" ? "lm-stamp--live" : undefined}
    >
      {STATE_LABELS[state]}
    </Badge>
  );
}
